﻿const stickyNav = {
  init: function() {
    this.mainDropdownBtn = document.getElementById("main-nav__btn");

    //Main nav scroll sticky
    if (document.querySelector("#subnav") == null) {
      window.addEventListener("scroll", () => {
        if (window.innerWidth > 991) {
          this.scrollLogo = document.querySelector("#header__logo--scroll");
          this.logo = document.querySelector("#header__logo");
          this.sticky = document.getElementById("main-nav");
          var changeLogo = 200;
          var elementTarget = 300;

          if (window.scrollY > changeLogo) {
            this.scrollLogo.style.display = "flex";
            this.logo.style.display = "none";
          } else {
            this.scrollLogo.style.display = "none";
            this.logo.style.display = "flex";
          }

          if (window.scrollY > elementTarget) {
            this.sticky.classList.add("navbar-fixed");
          } else {
            this.sticky.classList.remove("navbar-fixed");
          }
        }
      });
    } else {
      window.addEventListener("scroll", () => {
        if (window.innerWidth > 991) {
          this.sticky = document.getElementById("subnav");
            var elementTarget = 300;

          if (window.scrollY > elementTarget) {
            this.sticky.classList.add("navbar-fixed");
            this.sticky.classList.add("scroll-show");
          } else {
            this.sticky.classList.remove("navbar-fixed");
            this.sticky.classList.remove("scroll-show");
          }
        }
      });
    }

    this.events();
  },

    events: function () {
        if (this.mainDropdownBtn) {
            this.mainDropdownBtn.addEventListener("click", () => {
                this.toggleClass();
            });
        }
  },

    toggleClass: function () {
        if (this.sticky) {
            this.sticky.classList.toggle("navbar-fixed");
        }
  }
};

export default stickyNav.init();
